import React from 'react';
import { motion } from 'framer-motion';

const ProfileStrengthMeter = ({ percentage }) => {
  // Determine color based on percentage
  const getColor = () => {
    if (percentage < 30) return 'bg-red-500';
    if (percentage < 60) return 'bg-yellow-500';
    if (percentage < 80) return 'bg-blue-500';
    return 'bg-green-500';
  };
  
  // Determine label based on percentage
  const getLabel = () => {
    if (percentage < 30) return 'Just Started';
    if (percentage < 60) return 'Getting There';
    if (percentage < 80) return 'Almost Complete';
    return 'Profile Complete!';
  };
  
  return (
    <div className="w-full max-w-xs">
      <div className="flex items-center justify-between mb-1">
        <span className="text-sm font-medium text-gray-700">Profile Strength</span>
        <span className="text-sm font-medium text-gray-700">{percentage}%</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2.5 mb-1">
        <motion.div 
          className={`h-2.5 rounded-full ${getColor()}`}
          initial={{ width: '0%' }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        ></motion.div>
      </div>
      <div className="text-xs text-gray-500">{getLabel()}</div>
    </div>
  );
};

export default ProfileStrengthMeter;
